<template>
  <a @click="handleClick" :class="{ active: isActive }">
    <p>{{ count }}</p>
    <font-awesome-icon icon="heart" />
  </a>
</template>

<script>
export default {
  name: "LikeButton",
  computed: {},
  props: {
    content: Object,
  },
  methods: {
    handleClick() {
      const url = "/qvf/like.php";
      const obj = {
        category: this.content.genre,
        slug: this.content.side + this.content.index,
      };
      const method = "POST";
      const body = Object.keys(obj)
        .map((key) => key + "=" + encodeURIComponent(obj[key]))
        .join("&");
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
      };
      console.log(body);
      fetch(url, { method, headers, body })
        .then((response) => response.json())
        .then((json) => {
          console.log(url, json);
          this.isActive = json.liked;
          this.count = json.count;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    updateCount() {
      const url = `/qvf/like.php?category=${this.content.genre}&slug=${this.content.side}${this.content.index}`;
      console.log("get", url);
      fetch(url)
        .then((response) => response.json())
        .then((json) => {
          console.log(url, json);
          this.isActive = json.liked;
          this.count = json.count;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  data() {
    return {
      isActive: false,
      count: 0,
    };
  },
  watch: {
    $route() {
      this.updateCount();
    },
  },
  mounted() {
    this.updateCount();
  },
};
</script>
<style lang="scss" scoped>
a {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 2em;
  height: 2.5em;
  z-index: 1;
  opacity: 0;
  transition: all 0.1s;
}
.active {
  color: rgb(255, 128, 4);
}
</style>
